import React from "react";
import { Popover, Box, Stack, Button } from "@mui/material";
import { MuiColorInput } from "mui-color-input";

const sanitizeHex = (value) => {
  if (!value) {
    return "#000000";
  }
  return value;
};

export const QuillColorPickerPopover = ({
  open,
  anchorEl,
  color,
  onSelectColor,
  onClose,
  onClear,
}) => {
  const handleChange = (newValue) => {
    onSelectColor?.(sanitizeHex(newValue));
  };

  const handleClear = () => {
    onClear?.();
    onClose?.();
  };

  const handleConfirm = () => {
    onClose?.();
  };

  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      transformOrigin={{ vertical: "top", horizontal: "left" }}
      disableRestoreFocus
    >
      <Box sx={{ p: 2, width: 240 }}>
        <MuiColorInput
          value={sanitizeHex(color)}
          onChange={handleChange}
          format="hex"
          variant="outlined"
          fullWidth
        />
        <Stack direction="row" justifyContent="space-between" spacing={1} sx={{ mt: 1 }}>
          <Button size="small" color="inherit" onClick={handleClear}>
            Отмена
          </Button>
          <Button size="small" variant="contained" onClick={handleConfirm}>
            Сохранить
          </Button>
        </Stack>
      </Box>
    </Popover>
  );
};